/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-access-state-in-setstate */
import React, { PureComponent } from 'react';

import setLanguage from '../translations/general_trans';

export default class InterestStep extends PureComponent {
  constructor(props) {
    super(props);
    this.handleData = this.handleData.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.state = {
      data: {
        id: '',
        title: '',
        interests: [],
        types: []
      },
      cTrans: setLanguage('category', window.config.language_code),
      gTrans: setLanguage('general', window.config.language_code)
    };
  }

  handleData(value, checked, type) {
    const list = this.state.data.interests;
    const types = [...this.state.data.types];
    if (checked) {
      list.push(value);
      types.push(type);
    } else if (list.includes(value)) {
      const index = list.indexOf(value);
      list.splice(index, 1);
      types.splice(index, 1);
    }
    const oldData = { ...this.state.data };
    oldData.interests = list;
    oldData.types = types;
    this.setState({
      data: oldData
    });
  }

  handleNext() {
    const oldData = { ...this.state.data };
    oldData.id = this.state.cTrans.category_id;
    oldData.title = this.state.cTrans.category;
    this.setState({
      data: oldData
    });

    const data = [];
    data.push(this.state.data);
    this.props.onNextClick(data);
  }

  interestClick(num, type) {
    const arr = [this.input1, this.input2, this.input3, this.input4];
    arr[num].checked ? (arr[num].checked = false) : (arr[num].checked = true);
    this.handleData(arr[num].value, arr[num].checked, type);
  }

  render() {
    const { cTrans } = this.state;
    const { gTrans } = this.state;
    return (
      <section className="interest-section">
        <h4 className="categoryTitle">{gTrans.headlineStep2}</h4>
        {/* <p className="categoryTitle">{cTrans.category}</p> */}
        <div className="interests">
          <div className="container1 container">
            <input
              className="checkbox"
              type="checkbox"
              name="boot"
              value={cTrans.boot_id}
              id="terms"
              onChange={event =>
                this.handleData(
                  event.target.value,
                  event.target.checked,
                  'boots'
                )
              }
              ref={input1 => {
                this.input1 = input1;
              }}
            />
            <span className="checkmark"> </span>
            <p onClick={() => this.interestClick(0, 'boots')}>{cTrans.boot}</p>
          </div>
          <div className="container2 container">
            <input
              className="checkbox"
              type="checkbox"
              name="shirts"
              value={cTrans.shirt_id}
              id="terms"
              onChange={event =>
                this.handleData(
                  event.target.value,
                  event.target.checked,
                  'shirts'
                )
              }
              ref={input2 => {
                this.input2 = input2;
              }}
            />
            <span className="checkmark"> </span>
            <p onClick={() => this.interestClick(1, 'shirts')}>
              {cTrans.shirt}
            </p>
          </div>

          <div className="container3 container">
            <input
              className="checkbox"
              type="checkbox"
              name="goalkeeper"
              value={cTrans.goalkeeper_id}
              id="terms"
              onChange={event =>
                this.handleData(
                  event.target.value,
                  event.target.checked,
                  'goalkeeper'
                )
              }
              ref={input3 => {
                this.input3 = input3;
              }}
            />
            <span className="checkmark"> </span>
            <p onClick={() => this.interestClick(2, 'goalkeeper')}>
              {cTrans.goalkeeper}
            </p>
          </div>
          <div className="container4 container">
            <input
              className="checkbox"
              type="checkbox"
              name="kids"
              value={cTrans.kids_id}
              id="terms"
              onChange={event =>
                this.handleData(
                  event.target.value,
                  event.target.checked,
                  'kids'
                )
              }
              ref={input4 => {
                this.input4 = input4;
              }}
            />
            <span className="checkmark"> </span>
            <p onClick={() => this.interestClick(3, 'kids')}>{cTrans.kids}</p>
          </div>
        </div>
        <div className="continue">
          <button
            type="button"
            className="signup"
            onClick={() => this.handleNext()}
          >
            {gTrans.ctaNext}
          </button>
        </div>
      </section>
    );
  }
}
